export enum CopType {
	BUILDER = 'builder',
	CUBE_CAMERA = 'cubeCamera',
	SDF_FROM_OBJECT = 'SDFFromObject',
	SNAPSHOT = 'snapshot',
	VIDEO = 'video',
	WEB_CAM = 'webCam',
}

export enum CopTypeImage {
	IMAGE = 'image',
	IMAGE_EXR = 'imageEXR',
	IMAGE_HDR = 'imageHDR',
	IMAGE_KTX2 = 'imageKTX2',
}
